import { Component, OnInit } from '@angular/core';
import { CommonTriggerPanelComponent } from '../../../common/common-trigger-panel.component';
import { BoolEquals, Or, Rule, RuleInterface } from '@vendasta/automata';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyInputModule, SelectInputOptionInterface } from '@vendasta/galaxy/input';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { TriggerBaseRules } from '../../../common/decorators/trigger-rules.decorator';
import { CommonModule } from '@angular/common';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';

@Component({
  selector: 'automata-retail-payment-panel',
  templateUrl: './retail-payment-panel.component.html',
  styles: [
    `
      .padding {
        margin-top: 16px;
      }
    `,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    GalaxyAlertModule,
    MatButtonModule,
    MatCardModule,
    FormsModule,
    GalaxyFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    GalaxyPipesModule,
    GalaxyInputModule,
  ],
})
export class RetailPaymentPanelComponent extends CommonTriggerPanelComponent implements OnInit {
  statusControl: UntypedFormControl = new UntypedFormControl('any', Validators.required);

  options: SelectInputOptionInterface[] = [
    { label: 'AUTOMATIONS.EDITOR.TRIGGERS.RETAIL_PAYMENT.SUCCEEDS_OR_FAILS', value: 'any' },
    { label: 'AUTOMATIONS.EDITOR.TRIGGERS.RETAIL_PAYMENT.SUCCEEDS', value: 'succeeds' },
    { label: 'AUTOMATIONS.EDITOR.TRIGGERS.RETAIL_PAYMENT.FAILS', value: 'fails' },
  ];

  ngOnInit(): void {
    super.ngOnInit();
    if (this.triggerChoices?.rules?.length > 0) {
      const rule = Rule.fromRuleInterface(this.triggerChoices.rules[0]) as Or;
      const firstValue = rule.value[0].value as boolean;
      const secondValue = rule.value[1].value as boolean;
      if (firstValue && secondValue) {
        this.statusControl.setValue('succeeds');
      } else if (!firstValue && !secondValue) {
        this.statusControl.setValue('fails');
      } else {
        this.statusControl.setValue('any');
      }
    }

    this.options.map((o) => {
      if (o.value === this.statusControl.value) {
        o.selected = true;
      }
      return o;
    });

    // Nothing to async load so we can enable saving.
    this.savingEnabled$.next(true);
  }

  getControlsToValidateOnSave(): (UntypedFormControl | UntypedFormGroup | UntypedFormArray)[] {
    return [this.statusControl];
  }

  isFormValid(): boolean {
    //At least one must be chosen
    return !!this.statusControl.value;
  }

  @TriggerBaseRules
  getBaseRules(): RuleInterface[] {
    const b = new BoolEquals('{.retail_payment_successful}', false, '');
    // The same rule is used twice to allow the same base rules to cover true, false, and any
    // True: true or true
    // False: false or false
    // Any: true or false
    const or = new Or([b, b], '');

    return [or.toRuleInterface()];
  }

  fillRuleValues(rules: RuleInterface[]): RuleInterface[] {
    const or = Or.fromRuleInterface(rules[0]);
    if (this.statusControl.value === 'any') {
      or.value[0].value = true;
      or.value[1].value = false;
    } else if (this.statusControl.value === 'succeeds') {
      or.value[0].value = true;
      or.value[1].value = true;
    } else {
      or.value[0].value = false;
      or.value[1].value = false;
    }
    return [or.toRuleInterface()];
  }
}
